import { useContext } from 'react';
import './grossMarginGraph.style.scss';
import '../Tables/table.style.scss';
import { PdfContext } from 'utils/context';
import { v1 } from 'uuid';
import { lengthInInterval, truncateTab } from '../Generics/utilsFunctions';
import { useTranslation } from 'react-i18next';

const Tonnage = () => {
  const { t } = useTranslation();
  const { forecastCampaign, suggest, previous, tonnageRows } = useContext(PdfContext);
  const years = suggest?.years;

  const previousCount = previous ? 1 : 0;

  const headers = [
    t('simulation.common.campaign'),
    ...(previous ? [`${forecastCampaign.startYear - 1} - ${forecastCampaign.endYear - 1}`] : []),
    `${forecastCampaign.startYear} - ${forecastCampaign.endYear}`,
    ...Array(years.length - 1)
      .fill('')
      .map((_, i) => `${i + forecastCampaign.startYear + 1}-${i + forecastCampaign.endYear + 1}`),
  ];

  const flatRows = tonnageRows?.flatMap((row) => [
    { ...row, isChild: false },
    ...(row.children?.map((child) => ({ ...child, isChild: true })) ?? []),
  ]);

  const numberOfRowPerPage = 12;
  let toDuplicate = true;
  let repetition = 1;
  let pages = [];

  while (toDuplicate) {
    const truncatedResult = truncateTab(flatRows, numberOfRowPerPage, repetition);
    pages.push(
      buildTonnageTable(
        truncatedResult,
        repetition > 1 ? t('simulation.common.continued') : '',
        headers,
        t,
      ),
    );
    lengthInInterval(flatRows, repetition, numberOfRowPerPage)
      ? repetition++
      : (toDuplicate = false);
  }

  return pages;
};

const buildTonnageTable = (rows, message, headers, t) => {
  return (
    <article className="pdf-page" key={v1()}>
      <div className="marge_brute_graph">
        <h6 className="title_h6 title_key">
          {t('simulation.result.common.culturesNumbersTitle')} {message}
        </h6>
        <table className="table">
          <thead className="table_head">
            <tr className="key_table_tr">
              {headers.map((header, i) => (
                <th className="column_name" key={i} scope="col">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.map((row) => (
              <tr className="key_table_tr" key={v1()}>
                <td
                  className="value_table"
                  style={{ paddingLeft: row.isChild ? '24px' : undefined }}
                >
                  {row.id}
                </td>
                {row.data?.map((cell) => (
                  <td className="value_table" key={v1()}>
                    {cell.value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </article>
  );
};

export default Tonnage;
